<template>
  <div class="">
    <modal
      :show.sync="editQuestion"
      scrollable
      size="lg"
      header-classes="bg-primary p-3"
      body-classes="overflow-y-auto h65vh"
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        ASSESSMENT
      </h6>
      <div v-for="(item, ind) in assessment" :key="ind">
        <div class="px-4 pb-8 bg-ededed">
          <div class="headx flex justify-between items-center">
            <div>
              <p class="font-semibold text-2xl text-black">
                Assessment {{ ind + 1 }}
              </p>
            </div>
            <div>
              <feather-icon
                class="mx-2 cursor-pointer"
                icon="XIcon"
                svgClasses="w-6 h-6"
                @click="DeleteQue(ind)"
              ></feather-icon>
            </div>
          </div>
          <div class="question mt-2">
            <div class="w-full mb-4">
              <base-input
                v-model="item.question"
                placeholder="Type Question"
                class="w-full"
              ></base-input>
            </div>
          </div>
          <div
            class="asnwers flex items-center mb-2"
            v-for="(answer, index) in item.answers"
            :key="index"
          >
            <div class="rounded-full">
              <!-- <feather-icon
            class=""
            icon="CircleIcon"
            svgClasses="w-3 h-3 text-primary"
          ></feather-icon> -->
              <b-form-radio
                v-model="item.correctAnswer"
                :name="'answer-question-' + ind + '-' + index"
                :value="item.answers[index].name"
              ></b-form-radio>
            </div>
            <!-- <p class="font-bold mr-2 text-lg">{{ letter[index] }}</p> -->
            <div class="w-full flex relative">
              <base-input
                :placeholder="`Option ${index + 1}`"
                v-model="item.answers[index].name"
                @focus="AddNewAnswer(ind, index)"
                class="w-full cusrpr"
              ></base-input>

              <!-- <div class="bg-white absolute mr-2 right-12 top-1 divvert">
            <div class="active:bg-success p-2 mr-3  rounded-md">
              <feather-icon
                class="active:text-white"
                icon="CheckIcon"
                svgClasses="w-5 h-5 "
              ></feather-icon>
            </div>
            <div class="divvertmr-2"></div>
          </div> -->

              <div class="bg-white absolute right-2 top-1">
                <div class="active:bg-danger p-2 rounded-md">
                  <feather-icon
                    @click="DeleteAnswer(ind, index)"
                    class="active:text-white cursor-pointer"
                    icon="XIcon"
                    svgClasses="w-5 h-5"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <p class="text-sm text-right font-normal">
            EXPLAINATION OF CORRECT ANSWER
          </p>
          <textarea
            class="form-control mt-2"
            id="exampleFormControlTextarea3"
            v-model="item.explaination"
          ></textarea>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click="handleSave()">SAVE</base-button>
        <base-button type="secondary" class="ml-auto" @click="closeModal"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    editQuestion: Boolean,
    selectedQue: Object,
  },
  data() {
    return {
      assessment: [
        {
          question: "",
          answers: [],
          correctAnswer: "",
          explaination: "",
        },
      ],
      letter: ["A", "B", "C", "D", "E", "F"],

      QueData: [],
      assessData: [],
    };
  },
  watch: {
    selectedQue(newValue, oldValue) {
      this.assessment[0].question = newValue.question;
      this.assessment[0].answers = newValue.option.option;
      this.assessment[0].explaination = newValue.explaination;
      this.assessment[0].correctAnswer = newValue.selected;
    },
  },
  methods: {
    async handleSave() {
      this.assessment.forEach((assessment) => {
        assessment.answers.forEach((item) => {
          item.correctAns = assessment.correctAnswer === item.name;
        });
      });
      this.assessment.forEach((data) => {
        this.QueData.push({
          question: data.question,
          explaination: data.explaination,
          option: data.answers,
        });
      });
      //   console.log(this.QueData);
      const payload = {
        questionId: this.selectedQue._id,
        question: this.QueData[0].question,
        explaination: this.QueData[0].explaination,
        option: this.QueData[0].option,
      };
      // console.log(payload);
      // console.log(this.QueData);
      this.assessData = this.assessments;
      let index = this.assessData
        .map((x) => x.question.findIndex((a) => a._id == this.selectedQue._id))
        .toString();
      // console.log(index);
      let elem = this.assessData.map((x) => x.question[parseInt(index)]);
      elem[0].question = this.QueData[0].question;
      elem[0].explaination = this.QueData[0].explaination;
      elem[0].option.option = this.QueData[0].option;
      // console.log(elem);
      this.assessData.forEach((x) =>
        x.question.splice(parseInt(index), 1, elem[0])
      );
      this.$store.commit("eLearning/SET_ASSESSMENT", this.assessData);
      let loader = this.$loading();

      const data = await this.$store.dispatch(
        "eLearning/editQuestion",
        payload
      );
      if (data.code == 200) {
        loader.close();
        this.$swal.fire({
          title: "Edited",

          text: "Question has been Edited Successfully!",

          icon: "success",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
        this.QueData = [];

        this.closeModal();
      }
    },
    closeModal() {
      this.$emit("close-editQuestion");
    },
  },
  computed: {
    ...mapState("eLearning", ["assessments"]),
  },
};
</script>

<style>
.form-group {
  margin-bottom: 0px !important;
}
.divvert {
  border-right: 1px solid #ddd;
}
.cusrpr .form-control {
  padding-right: 7rem;
}
.custom-control-label::before {
  left: -2rem;
}
.custom-control-label::after {
  left: -2rem;
}
</style>
